module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/3b6105aed162d3d390459454545b4f47.png";